import { CateListConstantS } from '../../../../CateList/S/Constant/module/CateListConstantS.js';

export const PRICE_RANGE_FILTER_LIST_ID = 63;
export const HIDE_RANGE_CATE_LIST_FOR_EN_JP_IDS = [
  CateListConstantS.CLOTH_LIST_ID,
  CateListConstantS.KIDS_LIST_ID,
  CateListConstantS.SPORTS_LIST_ID,
  CateListConstantS.PET_LIST_ID,
];
